module.exports = __webpack_public_path__ + "media/images/investor-science-center-08b794ee.png";